import React from "react";
import { useContext, useEffect, useState } from "react";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import List from "./List";
import Pagination from "../Pagination";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import ODateRangePicker from "components/shared/datePicker/ODateRangePicker";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

const Orders = () => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const manager =
    user?.permission?.find((e) => e.manager === "property_manager") ?? {};

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [filterData, setFilterData] = useState({
    startDate: "",
    endDate: "",
    isReset: false,
    status: "",
    addedBy: "",
    isFilter: false,
    searchKey: "",
  });
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [sort, setSort] = useState({
    sortKey: "createdAt",
    sortType: "desc",
  });

  const { startDate, endDate, status, addedBy, searchKey } = filterData;

  const fetchProperties = async (data) => {
    try {
      const payload = {
        page,
        pageSize,
        startDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
        endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
        keyword: searchKey ? searchKey.trim() : null,
        sortKey: sort.sortKey,
        sortType: sort.sortType,
      };
      const path = apiPath.orders;
      const result = await apiGet(path, payload);
      const response = result?.data?.results;
      const resultStatus = result?.data?.success;
      setList(response?.docs);
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null,
      });
      console.log(response);
    } catch (error) {
      console.error("error in get all users list==>>>>", error.message);
    }
  };
  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  const handleDateChange = (start, end) => {
    setPage(1);
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true,
    });
  };

  const handleChange = (event) => {
    setFilterData({
      ...filterData,
      isFilter: true,
      // searchKey:event.target.value,
      [event.target.name]: event.target.value,
    });

    setPage(1);
  };

  const handleReset = () => {
    setFilterData({
      startDate: "",
      endDate: "",
      isReset: true,
      isFilter: false,
      status: "",
      addedBy: "",
      searchKey: "",
    });
    setPage(1);
  };

  useEffect(() => {
    fetchProperties();
    // eslint-disable-next-line
  }, [page, filterData, sort]);

  return (
    <div>
      <div className="bg-white">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] ">
            <form className="border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3">
              <div className="col-span-2 flex flex-wrap  items-center">
                <div className="flex items-center lg:pt-0 pt-3 flex-wrap">
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                  />
                  {/* <div className="flex items-center  ml-3 mb-3">
                    <select
                      id="status"
                      name="status"
                      className="block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                      placeholder=" "
                      value={status}
                      onChange={handleChange}
                    >
                      <option selected value="">
                        {t('O_ALL')}
                      </option>
                      <option value="active">{t('O_ACTIVE')}</option>
                      <option value="inactive">{t('O_INACTIVE')}</option>
                    </select>
                  </div>
                  <div className="flex items-center  ml-3 mb-3">
                    <select
                      id="addedBy"
                      name="addedBy"
                      className="block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                      placeholder=" "
                      value={addedBy}
                      onChange={handleChange}
                    >
                      <option selected value="">
                        {t('O_ALL')}
                      </option>
                      <option value="admin">{t('ADMIN')}</option>
                      <option value="agent">{t('ADMIN_S_AGENT')}</option>
                      <option value="freelancer">{t('AGENT')}</option>
                      <option value="company">{t('COMPANY')}</option>
                    </select>
                  </div> */}

                  <button
                    type="button"
                    onClick={handleReset}
                    className="bg-[#8FC150] text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2"
                  >
                    {t("O_RESET")}
                  </button>
                </div>
              </div>
              <div className="2xl:ml-auto xl:ml-0 lg:pt-0 pt-2">
                <label
                  htmlFor="default-search"
                  className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
                >
                  {t("O_SEARCH_PROPERTY")}
                </label>
                <div className="flex">
                  <div className="relative ">
                    <div className="absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none">
                      <svg
                        aria-hidden="true"
                        className="w-4 h-4 text-[#A5A5A5] dark:text-gray-40"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        {!filterData?.searchKey && (
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          />
                        )}
                      </svg>
                    </div>
                    <input
                      type="search"
                      id="default-search"
                      name="searchKey"
                      title=""
                      className="block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[300px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder={t("ORDER_SEARCH")}
                      value={searchKey}
                      required
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                </div>
              </div>
            </form>
            <List
              page={page}
              paginationObj={paginationObj}
              sort={sort}
              setSort={setSort}
              list={list}
              fetchProperties={fetchProperties}
              manager={manager}
            />
            {paginationObj?.totalItems?.length !== 0 && (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Orders;
